import { container, singleton } from "tsyringe";

import { BehaviorSubject, interval, Subject } from 'rxjs';
import { Participant, SequinParticipant } from '@bluejeans/webrtc-client-sdk';

import { WebRTCsdkService } from './webrtcsdk-service';
import { UserService } from './user-service';
import { PTApiService } from './ptapi-service';
import { PTSocketService } from './ptsocket.service';

import { MeetingConnectionState, PtMeeting } from '../models/meetingClass';

import * as R from 'ramda';
import { CnxProperties, EndpointDetail, People } from '../models/peopleClass';
import { setInterval } from 'timers';
import { debounce, filter, first } from 'rxjs/operators';
import { OrchestratorService } from './orchestrator-service';
import { ProducerType} from '../models/producerClass';


export const enum PeopleKind {
  ATTENDEE = 'Attendee',
  PRESENTER = 'Panelist',
  MODERATOR = 'Moderator',
  OUTDATED = 'OutDated',
}


@singleton()
export class PeopleService {

  public peoples$ = new BehaviorSubject<People[]>([]);

  private webRTCsdkService = container.resolve(WebRTCsdkService);
  private userService = container.resolve(UserService);
  private ptApiService = container.resolve(PTApiService);
  private ptSocketService = container.resolve(PTSocketService);
  private orchestratorService = container.resolve(OrchestratorService)

  private resetLayoutQueue$ = new Subject();

  private initialized = false;
  private cleanInterval = null;

  buildPeople(isSelf, participant):People {

    const people = new People({
      isSelf: isSelf,
      id: participant.id,
      name: participant.name,
      role: participant.role,
      status: participant.status,
      joinTime: participant.joinTime,
      csrc: participant.csrc || 0,
      streamIndex: isSelf ? 0 : -1,
      noParticipantDetectionDate: 0,
      inParticipantRoster: isSelf,
      camera: '',
      blurRange: 0,

      endpointGUID: participant.endpointGUID,
      seamGuid: participant.interactivityDetail?.endpointGUID,


      audioMute: participant.interactivityDetail?.audioMute,
      audioHardMute: participant.interactivityDetail?.audioHardMute,
      localAudioMute: participant.interactivityDetail?.localAudioMute,
      remoteAudioMute: participant.interactivityDetail?.remoteAudioMute,

      videoMute: participant.interactivityDetail?.videoMute,
      videoHardMute: participant.interactivityDetail?.videoHardMute,
      localVideoMute: participant.interactivityDetail?.localVideoMute,

      shareScreen: participant.interactivityDetail?.screenShare || false,
      speaking: participant.interactivityDetail?.speaking || false,
      voiceProcessing: participant.interactivityDetail?.voiceProcessing ||false,

      callQuality: !participant.interactivityDetail?.callQuality ?
         5 : participant.interactivityDetail.callQuality,
      contentShareMute: participant.interactivityDetail?.contentShareMute || false,

      properties: (participant.interactivityDetail?.properties) as CnxProperties,
      endpointDetail: (participant.endpointDetail) as EndpointDetail,
    });

    return people;
  }


  sortOnTimestamp(a ,b) {
    return a.timestamp - b.timestamp;
  }



  async initialize() {

    this.initialized = true;
    const guid = this.ptSocketService.socketGuidValue;

    let peoples: People[] = [];
    // const participants = await this.ptApiService.getRosterInteractive();
    // if (participants && participants.length > 0) {
    //   for (let p of participants) {
    //     const isSelf = guid === p.endpointGUID;
    //     if (p.status !== 'DISCONNECTED' && p.status !== 'BLOCKED') {
    //       const people = this.buildPeople(isSelf, p);
    //       peoples.push(people);
    //     }
    //   }
    // }
    // const attendees = await this.ptApiService.getRosterAttendees();
    // if (attendees && attendees.length > 0) {
    //   for (let p of attendees) {
    //     p.isSelf = false;
    //     if (p.status !== 'DISCONNECTED' && p.status !== 'BLOCKED') {
    //       const people = this.buildPeople(false, p);
    //       peoples.push(people);
    //     }
    //   }
    // }


    console.log('PEOPLES at init', peoples);
    this.peoples$.next(peoples);

    // add observable
    this.ptSocketService.rosterEventObservable.subscribe((msg) => this.handleSocketRosterEvent(msg));

    this.webRTCsdkService.participantsEventObservable.subscribe((participants:Participant[]) => this.handleParticipantEvent(participants))

    this.webRTCsdkService.sequinsEventObservable.subscribe((seqParticipants:SequinParticipant[]) => this.handleSequinEvent(seqParticipants))

    const cleanInterval = setInterval(()=> {
      this.cleanOutdatedPeople();
    }, 5000);

    this.resetLayoutQueue$
    .pipe(debounce(() => interval(2000)))
    .subscribe(async (val) => {
      try {
        console.log('RESET constance presence layout')
        this.ptApiService.setConstancePresenceLayout();
      } catch (e) {
      }
    });

  }

  addPeople(uuid: string, url: string, name: string, prodType: ProducerType) {

    const peoples = this.peoples$.getValue();

    const people = this.buildPeople(
      name === 'Me', // isself
      {
        created: 1645128739073,
        detail: { description: null, gplusId: null, linkedinURI: null, profilePictureURI: null, title: null, twitterId: null },
        endpointDetail: { browser: "chrome", epType: "WebRTC", flashVersion: "1.0", os: "mac" },
        endpointGUID: uuid,
        greenroomCapable: null,
        id: uuid,
        interactivityDetail: {
          audioHardMute: false,
          audioMute: true,
          callGUID: "2c12d9e8-069f-460f-8045-78c53a159204",
          callQuality: 0,
          contentShareMute: false,
          endpointGUID: uuid,
          id: 0,
          layout: "4",
          localAudioMute: false,
          localVideoMute: false,
          properties: { audioRecvCodec: "Opus", audioSendCodec: null, contentRecvHeight: null, contentRecvWidth: null, endpoint: "SkinnyChat", pin: false, sublayout: "3", videoRecvCodec: "VP8", videoRecvHeight: 720, videoRecvWidth: 1280, videoSendCodec: "VP8", videoSendHeight: 720, videoSendWidth: 1280 },
          remoteAudioMute: false,
          remoteVideoMute: false,
          screenShare: false,
          speaking: false,
          sync: true,
          videoHardMute: false,
          videoMute: false,
          voiceProcessing: true,
        },
        joinTime: Date.now(),
        languagesSelected: null,
        leaveTime: null,
        name: name,
        prevRole: null,
        pstnParticipantInfo: null,
        raiseHandApprovedTime: null,
        raiseHandState: null,
        raiseHandTime: null,
        role: name === "Me" ? "Moderator" : "Presenter",
        sharingUrl: null,
        status: "ACTIVE",
        userGreenroomStatus: null
      }
    );
    people.isSelf = name === 'Me';
    people.inParticipantRoster = true;
    people.noParticipantDetectionDate = 0;
    people.url = url;
    people.type = prodType;


    peoples.push(people);

    this.peoples$.next(peoples);

  }


  cleanOutdatedPeople() {
    const peoples: People[] = R.clone(this.peoples$.getValue());
    let needUpdate = false;
    for (const people of peoples.filter(p => p.noParticipantDetectionDate > 0 && p.inParticipantRoster)) {
      if (Date.now() - people.noParticipantDetectionDate > 5000) {
        console.log('PEOPLE marked as OUTDATED', people.name, people.endpointGUID);
        people.inParticipantRoster = false;
        needUpdate = true;
      }
    }
    if (needUpdate) {
      this.peoples$.next(peoples);
    }
  }


  handleParticipantEvent(participants: Participant[]) {

    if (participants.length === 0) return;

    // check if any of the people is in participant list
    const peoples: People[] = R.clone(this.peoples$.getValue());
    let needUpdate = false;
    for (const people of peoples) {
      const participant = participants.find(p => p.participantGuid === people.seamGuid);

      // if (participant)
      // console.log('network quality', participant.name, participant.callQuality);

      if (!participant) {
        if (!people.isSelf) {
          console.log('PEOPLE has no participant', people.name, people.endpointGUID);
          if (people.noParticipantDetectionDate == 0) {
            people.noParticipantDetectionDate = Date.now();
            needUpdate = true;
          } else if (people.inParticipantRoster) {
            if (Date.now() - people.noParticipantDetectionDate > 5000) {
              people.inParticipantRoster = false;
              needUpdate = true;
            }
          }
        }

      } else {
        // reset field
        if (!people.inParticipantRoster || people.noParticipantDetectionDate>0 ) {
          people.inParticipantRoster = true;
          people.noParticipantDetectionDate = 0;
          needUpdate = true;
        }
        if (people.shareScreen !== participant.isSharing) {
          people.shareScreen = participant.isSharing;

          if (people.shareScreen) {
            console.log('ROSTER screen share', people.name, people.shareScreen ? 'TRUE' : 'FALSE');
          }

          needUpdate = true;
        }
        if (people.audioMute !== participant.isAudioMuted) {
          // roster audio is not consistent with people
          this.webRTCsdkService.setAudioMuted(people.audioMute)
        }
        if (people.videoMute !== participant.isVideoMuted) {
          // roster video is not consistent with people
          this.webRTCsdkService.setVideoMuted(people.videoMute)
        }
        if (people.csrc !== participant.csrc) {
          people.csrc = participant.csrc;
          needUpdate = true;
        }
      }
    }
    if (needUpdate) {
      this.peoples$.next(peoples);
    }
  }

  handleSequinEvent(seqParticipants: SequinParticipant[]) {
    if (seqParticipants.length === 0) return;

    // check if any of the people is in participant list
    const peoples: People[] = R.clone(this.peoples$.getValue());
    let needUpdate = false;
    for (const people of peoples) {
      const sequin = seqParticipants.find(p => p.participant.participantGuid === people.seamGuid);

      if (sequin) {
        console.log('===== PEOPLE SEQ', people, sequin);
        console.log('===== network', sequin.networkLevel, sequin.participant.callQuality);

        if (people.csrc !== sequin.csrc) {
          people.csrc = sequin.csrc;
          needUpdate = true;
        }
        let streamIndex = -1;
        if (typeof sequin.streamIndex !== 'undefined') {
          streamIndex = sequin.streamIndex + 1;
        } else {
          streamIndex = -1;
        }
        if (people.isSelf) {
          streamIndex = 0;
        }
        if (people.streamIndex !== streamIndex) {
          people.streamIndex = streamIndex;
          needUpdate = true;
        }
      }
    }
    if (needUpdate) {
      this.peoples$.next(peoples);
    }

  }

  forceUpdateCamera(camera) {
    const peoples: People[] = R.clone(this.peoples$.getValue());
    const p = peoples.find(p => p.isSelf);
    if (p) {
      p.camera = camera;
    }
    this.peoples$.next(peoples);
  }
  forceUpdateBlur(range) {
    const peoples: People[] = R.clone(this.peoples$.getValue());
    const p = peoples.find(p => p.isSelf);
    if (p) {
      p.blurRange = range;
    }
    this.peoples$.next(peoples);
  }


  handleSocketRosterEvent(msg) {

    if (!msg) return;

    try {

      let needToResetUserLayout = false;

      let isSelf = false;
      const guid = this.ptSocketService.socketGuidValue;
      if(msg.notificationType!=='Last_Moderator_Leave' && guid === msg.participant?.endpointGUID ){
        isSelf = true;
      }

      if (msg.participant && msg.participant.id) {

        // console.log('network quality', msg.participant.name, msg.participant.interactivityDetail?.callQuality);

        const people = this.buildPeople(isSelf, msg.participant);
        // console.log(people);
        console.log({name: people.name, audioMute: people.audioMute, audioHardMute: people.audioHardMute, videoMute: people.videoMute, videoHardMute: people.videoHardMute})

        if (msg.participant.interactivityDetail?.properties?.sublayout !== '1') {
          needToResetUserLayout = true;
        }

        // check if it exits in queue
        let peoples = R.clone(this.peoples$.getValue());
        let old = peoples.find((p: any) => people.id ===
        p?.id);

        if (!old) {

          // add this new people in attendees list
          if (people.status !== 'DISCONNECTED' && people.status !== 'BLOCKED') {

            if (people.isSelf) {
              // use prejoin muted state for self
              const prejoinMute = JSON.parse(localStorage.getItem('prejoinMute') || "{ video: true, audio: true}" );
              people.audioMute = prejoinMute.audio;
              people.videoMute = prejoinMute.video;
              this.webRTCsdkService.setAudioMuted(people.audioMute);
              this.webRTCsdkService.setVideoMuted(people.videoMute);
              this.orchestratorService.meetingInitializedObservable.pipe(first()).toPromise().then((meetingConnected) => {
                console.log('ORCHESTRATOR state', meetingConnected, Date.now())
                this.ptApiService.setParticipantMute(people.endpointGUID, 'audio', people.audioMute, false);
                this.ptApiService.setParticipantMute(people.endpointGUID, 'video', people.videoMute, false);
              });
            }

            peoples.push(people);
            this.peoples$.next(peoples);
            console.log('PEOPLE aftnew', peoples);
          }

        } else {

          // check for mute/hard inconsistency
          if (people.audioHardMute && !people.audioMute) {
            people.audioMute = true;
            this.ptApiService.setParticipantMute(people.endpointGUID, 'audio', true, true);
          }
          // force old values for these fields
          people.csrc                       = old.csrc;
          people.streamIndex                = old.streamIndex;
          people.noParticipantDetectionDate = old.noParticipantDetectionDate;
          people.inParticipantRoster        = old.inParticipantRoster;
          people.shareScreen                = old.shareScreen;

          if (!R.equals(old, people)) {

            if (people.shareScreen) {
              console.log('screen share', people.name, people.shareScreen ? 'TRUE' : 'FALSE');
            }

            // replace existing people
            peoples = peoples.filter((p: any) => p.id !== people.id);
            if (people.isSelf || (people.status !== 'DISCONNECTED' && people.status !== 'BLOCKED')) {
              peoples.push(people);
              // update in case of replace
              this.peoples$.next(peoples);
              console.log('PEOPLE aftupd', peoples);
            }
            // if (people.isSelf && people.status === 'DISCONNECTED') {
              // an other moderator ended the meeting => do EXIT routine
              // handle this case in SideNav component and closeExit
            // }
          }
        }

        if (needToResetUserLayout) {
          this.resetLayoutQueue$.next('');
        }

      }

    } catch (error) {
      console.log('PEOPLE error', error);
    }
  }

  findPeople(seamGuid) : People {
    const peoples = this.peoples$.getValue();
    const people = peoples.find(p => p.seamGuid === seamGuid);
    return people;
  }

  getMySelf() : People {
    const peoples = this.peoples$.getValue();
    const people = peoples.find(p => p.isSelf);
    return people;
  }

  getPresenterIds() : number[] {
    const peoples = this.peoples$.getValue();
    // const ids = peoples.map(p => p.userid);
    const ids = [];
    return ids;
  }

  renameParticipantByGuid(name: string, endpointGuid: string ) {
    const peoples: People[] = R.clone(this.peoples$.getValue());
    const p = peoples.find(p => p.endpointGUID === endpointGuid);
    if (p) {
      p.name = name;
      this.peoples$.next(peoples);
    }
  }

  setParticipantMute(endpointGuid: string, media: 'video' | 'audio', mute: boolean, hard: boolean) {

    if (!endpointGuid || endpointGuid.length <= 6) return;

    const peoples: People[] = R.clone(this.peoples$.getValue());
    const p = peoples.find(p => p.endpointGUID === endpointGuid);
    if (p) {
      if (media === 'audio') {
        if (!hard) {
          p.audioMute = mute;
        } else {
          p.audioHardMute = mute;
        }
      } else {
        if (!hard) {
          p.videoMute = mute;
        } else {
          p.videoHardMute = mute;
        }
      }
      this.peoples$.next(peoples);
    }
  }

  kickoutParticipant(endpointGuid, role) {
    let peoples: People[] = R.clone(this.peoples$.getValue());
    peoples = peoples.filter(p => p.endpointGUID !== endpointGuid);
    this.peoples$.next(peoples);
  }

  setPresentersMute(mute: boolean) {
    const peoples: People[] = R.clone(this.peoples$.getValue());
    peoples.forEach(p => p.audioMute = mute);
    this.peoples$.next(peoples);
  }

  setVoiceProcessing(endpointGuid, state) {
    const peoples: People[] = R.clone(this.peoples$.getValue());
    const p = peoples.find(p => p.endpointGUID === endpointGuid);
    if (p) {
      p.voiceProcessing = state;
      this.peoples$.next(peoples);
    }
  }

}
